<template>
  <!-- Start: .grid .project-gallery -->
  <div
    class="grid-item col-md-4 col-sm-6 col-xs-12"
    :class="spread(stack.categories)"
  >
    <figure>
      <lazy-image :source="stack.location" :alt="stack.subtitle" />
      <figcaption class="fig-caption">
        <i class="fa fa-search"></i>
        <h5 class="title" v-html="stack.title"></h5>
        <span class="sub-title" v-html="stack.subtitle"></span>
        <!-- <a :href="stack.location" data-fancybox="gallery" data-src="#mh"></a> -->
        <a :href="stack.location" data-fancybox="gallery" @click="viewMore"></a>
      </figcaption>
    </figure>
  </div>
  <!-- End: .grid .project-gallery -->
</template>

<script>
export default {
  props: {
    stack: {
      required: true,
      type: Object,
      default: () => {},
    },
  },

  methods: {
    // A method to filter through the array and get the "tag" attributes
    spread(arr) {
      let tag = "";
      if (typeof arr != "undefined" && arr.length)
        arr.forEach((elem) => {
          tag += ` ${elem}`;
        });
      return tag;
    },

    viewMore() {
      Event.$emit("view-more", this.stack);
    },
  },
};
</script>

<style>
.img-p {
  max-width: initial;
  height: initial;
}
</style>
